import {
  cn,
  FormControl,
  FormItem,
  FormMessage,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@racefront/shadcn-ui'
import { ControllerRenderProps } from 'react-hook-form'
import { supportedLocales, SuppotedLocales } from '@racefront/common/i18n/types'

const localeNames: Record<SuppotedLocales, string> = {
  [SuppotedLocales.EN_GB]: 'English',
  [SuppotedLocales.SV_SE]: 'Svenska',
  [SuppotedLocales.EL_GR]: 'Ελληνικά',
}

type Props = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  field: ControllerRenderProps<any, any>
}

export default function LocaleSelect({ field }: Props) {
  return (
    <FormItem>
      {/* <FormLabel>{field.name}</FormLabel> */}
      <Select onValueChange={field.onChange} defaultValue={field.value}>
        <FormControl>
          <SelectTrigger>
            <SelectValue placeholder="Select a verified email to display" />
          </SelectTrigger>
        </FormControl>
        <SelectContent>
          {supportedLocales.map((locale) => (
            <SelectItem key={locale} value={locale}>
              <div className="flex items-center gap-2">
                <div className={cn('fi', `fi-${locale?.split('-')[1]}`)} />
                <span>{localeNames[locale]}</span>
              </div>
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
      <FormMessage />
    </FormItem>
  )
}
